import HistoryTableRow from './HistoryTableRow';

export default HistoryTableRow;
